import { Link, usePage } from "@inertiajs/react"
import { useEffect, useState } from "react"
import { updateGeneral } from "@/Redux/features/pages/Customize/customize"
import { useDispatch } from "react-redux"
import NavigationLink from "@/Components/NavigationLink"
import PoweredBy from "@/Components/PoweredBy"
import translate from "@/utils/translate"

export default function AuthLayout({ children }) {
    const customize = localStorage.getItem("customize_settings") 
        ? JSON.parse(localStorage.getItem("customize_settings")) 
        : []
    const { lang } = usePage().props
    const dispatch = useDispatch()
    const defaultLang = lang?.default_lang ?? "en"
	const { auth_bg_image } = JSON.parse(localStorage.getItem("page_settings")) ?? {}

    useEffect(() => {
        const generalSettings = localStorage.getItem("general_settings") 
            ? JSON.parse(localStorage.getItem("general_settings")) 
            : {}
        dispatch(updateGeneral(generalSettings))
    }, [dispatch, defaultLang])

    return ( 
        <> 
            <div className="cs_auth_card" style={{ backgroundImage: `url(${auth_bg_image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center'}}>
                {/* Left Card */} 
                <div className="cs_card_left">
                    <div className="cs_card_card_out">
                        <div className="cs_card_card_in">
                            <NavigationLink href={route("home")} className="cs_login_logo">
                                <img src={customize?.general?.site_logo_dark ?? ""} alt={translate("Site logo")} />
                            </NavigationLink>
                            {children}
                        </div>
                    </div>
                </div>
            </div>	

			<PoweredBy />			
        </>
    )
}